import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import TeamFilter from '../navigation/team-filter';
import CategoryFilter from '../navigation/category-filter';
import MonthFilter from '../navigation/month-filter';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';

const openStyle = {
  transition: 'opacity 0.3s linear',
  opacity: 1,
  height: 'auto',
};

const closedStyle = {
  transition: 'opacity 0.3s linear',
  opacity: 0,
  height: 0,
  overflow: 'hidden',
};

const NewsFilters = ({
  category,
  club,
  categoryFilters,
  month,
  openFilter,
  sections,
  selectedTeam,
  onChangeTeamFilter,
  onChangeCategoryFilter,
  onChangeMonthFilter,
  teamId,
  t,
}) => {
  let content;

  if (openFilter === 'team') {
    content = (
      <TeamFilter
        name="team"
        club={club}
        sections={sections}
        selected={teamId}
        label={selectedTeam ? selectedTeam.name : t('common:team_filter_label')}
        onChange={onChangeTeamFilter}
      />
    );
  } else if (openFilter === 'category') {
    content = (
      <CategoryFilter
        name="category"
        selected={category}
        categories={categoryFilters}
        label={category ? t(`common:${category}_activity_type`) : t('news:category_filter_label')}
        onChange={onChangeCategoryFilter}
      />
    );
  } else if (openFilter === 'month') {
    content = (
      <MonthFilter
        name="month"
        earliestMonth={club.oldest_published_news_article_date}
        selected={month}
        label={
          month
            ? DateTime.fromFormat(`${month}-01`, 'yyyy-MM-dd').toFormat('MMM yy')
            : t('news:month_filter_label')
        }
        onChange={onChangeMonthFilter}
      />
    );
  }

  return (
    <>
      <div style={content ? openStyle : closedStyle}>{content}</div>
    </>
  );
};

NewsFilters.defaultProps = {
  category: null,
  month: null,
  openFilter: null,
  selectedTeam: null,
  teamId: null,
};

NewsFilters.propTypes = {
  category: PropTypes.string,
  categoryFilters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  club: CLUB_PROP_TYPES.isRequired,
  month: PropTypes.string,
  onChangeCategoryFilter: PropTypes.func.isRequired,
  onChangeMonthFilter: PropTypes.func.isRequired,
  onChangeTeamFilter: PropTypes.func.isRequired,
  openFilter: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      teams: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  selectedTeam: PropTypes.shape({
    name: PropTypes.string,
  }),
  t: PropTypes.func.isRequired,
  teamId: PropTypes.number,
};

export default NewsFilters;
